import Todo from '../models/Todo';
import {localAxiosRequest} from "@/utils/axios";
const COMMON_BASE_URL = '/common';

/**
 * 获取token
 * 第一次进入页面时，登录成功后需要调用该接口
 */
const getToken = function (): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${COMMON_BASE_URL}/token`,
    });
};

export { getToken };
